export default {
  adlQueue:
    'This indicator shows your position in the auto-deleverage queue. If all lights are lit, in the event of a liquidation, your position may be reduced.',
  markPrice:
    'The latest mark price for this contract. This is the price used for PNL and margin calculations, and may differ from the last price for the purposes of avoiding price manipulation.',
  entryPrice: 'Average executed buy/sell price for your current long/short position.',
  unrealizedPnl: 'Unrealized profit and loss on this position calculated based on Mark Price.',
  liquidationPrice:
    'If the mark price of the contract reaches below this price (when long) or above this price(when short), your position will be liquidated.',
  liquidationPriceTip: 'Liquidation price after execution for the total position.',
  marginRatio:
    'Margin Ratio = Maintenance Margin / Margin Balance. Your positions will be liquidated once Margin Ratio reaches 100%.',
  walletBalance:
    'Wallet Balance = Total Net Transfer + Total Realized Profit + Total Net Funding Fee - Total Commission.',
  marginBalance:
    'Margin Balance = Wallet Balance + Unrealized PNL. Your positions will be liquidated once Margin Balance <= Maintenance Margin.',
  maintenanceMargin:
    'The minimum amount of margin balance you must maintain to keep the open positions.',
  initialMarginRequired:
    'The minimum amount of margin balance you must possess to open the new positions. ',
  availableForOrder:
    'Available for Order = Margin Balance - Initial Margin. The total amount you can use to open new positions.',
  availableForWithdraw:
    'Available for Withdraw = min (Wallet Balance, Available for Order). The total amount you can withdraw from future wallet.',
  funding: 'The payment rate exchanged between the buyer and seller for the next funding.',
  countdownTime: 'Time left to the next funding.',
  closePosition:
    'You can close your entire position here, which will enter an order with the opposite size at market price or limit price defined by you.',
  transferUnavailable: 'Transfer is not available in testnet.'
}
